// extracted by mini-css-extract-plugin
module.exports = {"infoText":"_987459a","root":"_302c377","info":"_481291e"};